import { reqGet, reqPut } from './axiosFun';

// 更新系统参数
export const sysParamUpdate = (params) => { return reqPut("/sys-param/", params) };

// 查询系统参数
export const sysParamGet = (params) => { return reqGet("/sys-param/detail", params) };

// 检测系统参数
export const sysParamCheck = (params) => { return reqGet("/sys-param/check", params) };

// 获取可用模型列表
export const sysParamModels = () => { return reqGet("/sys-param/models", {}) };



// WEBPACK FOOTER //
// ./src/api/sysParam.js